// extracted by mini-css-extract-plugin
export default {"container":"PS-z","topReviewHeading":"QS-z","criticalReview":"RS-z","favorableReview":"SS-z","vsSeparator":"TS-z"};